// utils/s3Upload.js

import { uploadS3 } from "../api/apiHandler";

export const uploadFileToS3 = async (file, folderName) => {
  try {
    const fileNameWithoutExtension = file.name.split('.')[0];
    const fileExtension = file.name.split('.').pop();
    const file_name = `${fileNameWithoutExtension}.${fileExtension}`;

    const s3Response = await uploadS3({
      image_folders: [
        {
          bucket_folder_name: folderName,
          file_type: file_name,
        },
      ],
    });

    const signedUrl = s3Response?.data?.[0]?.url;
    if (!signedUrl) throw new Error("Failed to get signed URL");

    const uploadResponse = await fetch(signedUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error(`Upload failed: ${uploadResponse.statusText}`);
    }

    const fileUrl = signedUrl.split("?")[0];
    const fileName = fileUrl.substring(fileUrl.lastIndexOf("/") + 1);
    return {
      url: fileUrl,
      fileName,
      fileType: file.type,
    };
  } catch (err) {
    console.error("uploadFileToS3 error:", err);
    throw err;
  }
};
